import { render, staticRenderFns } from "./matriz.vue?vue&type=template&id=01da91bb&scoped=true"
import script from "./matriz.vue?vue&type=script&lang=js"
export * from "./matriz.vue?vue&type=script&lang=js"
import style0 from "./matriz.vue?vue&type=style&index=0&id=01da91bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da91bb",
  null
  
)

export default component.exports